import { useCallback, useEffect, useRef, useState } from 'react';
import { LayoutComponent } from '../LayoutComponent';
import { Cell, Column, Row, TableView, TableBody, TableHeader, Flex, Heading, Content, View, Link, ProgressCircle, Checkbox, Dialog, DialogContainer, DialogTrigger, Divider, ActionButton } from '@adobe/react-spectrum';
import { useAsyncList } from 'react-stately';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import TaskListAddEdit from './TaskListAddEdit';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import { ToastQueue } from '@react-spectrum/toast';
import { FPAData, FPADataTypes } from '../../../../infra/protected/FPA/FPAData';
import { AlertIconFill, EditIcon } from '../../Icons/IconsLib';
import useComonentReload from '../../../../hooks/UseComponentReload';
import { GetContextPathRequest } from '../../../../services/soap/project/requests/GetContextPathRequest';
import { GetSchedulerSettingsRequest, SettingsItemType } from '../../../../services/soap/scheduler/requests/GetSchedulerSettingsRequest';
import { ListUserRequest } from '../../../../services/soap/access/requests/ListUserRequest';
import { ListTaskRequest } from '../../../../services/soap/scheduler/requests/ListTaskRequest';
import { DeleteTaskRequest } from '../../../../services/soap/scheduler/requests/DeleteTaskRequest';
import { UpdateTaskRequest } from '../../../../services/soap/scheduler/requests/UpdateTaskRequest';
import { CreateTaskRequest } from '../../../../services/soap/scheduler/requests/CreateTaskRequest';
import { generateTaskItem } from '../../../../services/soap/scheduler/requests/CreateTaskOptions';
import { GetUserRequest } from '../../../../services/soap/access/requests/GetUserRequest';
import { useTableViewHeight } from '../../../../utils/tableViewUtils';
import styles from './TaskListComponent.module.css';
import AddUpdateTask from '../../../../pages/protected/task/components/AddUpdateTask';
import { CLOSED_TITLES, normalizeText, statusColor } from '../../../../utils/helperUtil';
import { GetTaskRequest } from '../../../../services/soap/scheduler/requests/GetTaskRequest';
import { CircleFill } from 'react-bootstrap-icons';
import { getTypeOfWorkFromLogin, TypeOfWorkBinding } from '../../../../utils/LoginUtils';
interface TaskListProps {
  showTopControls?: boolean;
  selectedItem?: FPAData;
}

export interface RowData {
  ident: number;
  userId: string;
  title: string;
  entryType: string;
  entryTypeName: string;
  dealLine: string;
  solutionStatus: string;
  statusName: string;
  completed: boolean;

  headId: string;
}
interface Character {
  completed: string;
  entryTypeName: string;
  title: string;
  deadLine: string;
  statusName: string;
}

type typeTaskListSearchParam = {
  rangeStart: Date;
  rangeEnd: Date;
  userId: string;
  folderId: string;
  projectId?: string;
  activityId?: string;
  countOnly?: string;
  limit?: number;
  offset?: number;
  anyTime: string;
  includePast: string;
  dateOfInterest: string;
  groupUsers: string;
  multiUser: string;
};

type typeTaskListCreateParam = {
  activityId: string;
  projectId: string;
  folderId: string;
  userId: string;
  title: string;
  typeOfWorkId: string;
  solverId: string;
  solutionStatusId: string;
  u_item?: any;
};

function TaskList({ showTopControls, selectedItem }: TaskListProps) {
  const [showAdd, setShowAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedDataRow, setSelectedDataRow] = useState<any>();
  const { t } = useTranslation('task');
  const _tt = (key: string) => t(`task_common.${key}`, { ns: 'task' });
  const PAGE_SIZE: number = 50;

  let columnsData = [
    { name: '', key: 'completed', width: 25 },
    { name: t('type', { ns: 'layout_components' }), key: 'entryTypeName', width: 170 },
    { name: t('title', { ns: 'layout_components' }), key: 'title', width: 400 },
    { name: t('priority', { ns: 'layout_components' }), key: 'priority', width: 100 },
    { name: t('task_owner', { ns: 'layout_components' }), key: 'userName', width: 170 },
    { name: t('deadline', { ns: 'layout_components' }), key: 'deadLine', width: 120 },
    { name: t('status', { ns: 'layout_components' }), key: 'statusName', width: 130 },
    { name: '', key: 'edit', width: 15 },
  ];

  let columnsDataMobile = [
    { name: '', key: 'completed', width: 25 },
    { name: t('type', { ns: 'layout_components' }), key: 'entryTypeName', width: 170 },
    { name: t('title', { ns: 'layout_components' }), key: 'title', width: 400 },
    { name: t('priority', { ns: 'layout_components' }), key: 'priority', width: 100 },
    { name: t('task_owner', { ns: 'layout_components' }), key: 'userName', width: 170 },
    { name: t('deadline', { ns: 'layout_components' }), key: 'deadLine', width: 120 },
    { name: t('status', { ns: 'layout_components' }), key: 'statusName', width: 130 },
    { name: '', key: 'edit', width: 15 },
  ];

  let defaultRowData: RowData = {
    ident: 0,
    userId: '',
    title: 'New task',
    entryType: '',
    entryTypeName: '',
    dealLine: '',
    solutionStatus: '',
    statusName: '',
    completed: false,
    headId: '',
  };

  const [reloadComponent] = useComonentReload();
  const { accessService, schedulerService, projectService, store } = useDependency();
  const { isMobile } = useViewInfo();
  const [taskListData, setTaskListData] = useState<any>([]);
  const [rowsData, setRowsData] = useState<any>([]);
  const [totalTaskListRec, setTotalTaskListRec] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<RowData>(defaultRowData);
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [showAddEditRow, setShowAddEditRow] = useState<boolean>(false);
  const [selectedKeys, setSelectedKeys] = useState<Set<any>>();
  const [typeofWorkList, setTypeofWorkList] = useState<any>([]);
  const [typeOfWorkFormattedList, setTypeOfWorkFormattedList] = useState<any>([]);
  const [userData, setUserData] = useState<any>([]);
  const [statusListData, setStatusListData] = useState<any>(null);
  const [taskStatusFormattedList, setTaskStatusFormattedList] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [checkSelected, setCheckSelected] = useState(false);

  const dataRef = useRef<any>({});

  useEffect(() => {
    (async () => {
      const { LIST } = await projectService.getContextPath(new GetContextPathRequest(store.Server, store.SessionId, Number(selectedItem?.id)));
      //console.log('contextRespone', contextRespone);
      const folderID = selectedItem ? LIST[selectedItem.type === FPADataTypes.ACTIVITY ? 1 : 0]?.CONTEXT[selectedItem.type === FPADataTypes.FOLDER ? 'id' : 'parentId'] : undefined;
      //console.log('folderID', folderID);
      dataRef.current = { folderID };
      Promise.all([getStatusList(), getTypeofWorkList()])
        .then(() => {
        })
        .catch((error) => {
          console.error("One of the requests failed:", error);
        });
      getUserCount().then((totalRecords: any) => getUserData(totalRecords));
      setShowLoader(false);
    })();
  }, []);

  useEffect(() => {
    setCheckSelected(false);
    setShowAddEditRow(false);
    listTaskList.reload();
  }, [reloadComponent, selectedItem?.id]);

  const getStatusList = useCallback(async () => {
    const statusArray: any = [];
    let res: any = await schedulerService.getSchedulerSettings(new GetSchedulerSettingsRequest(store.Server, store.SessionId,
      '1', SettingsItemType.TASK_ITEM_TYPE, 50, 0));
    if (res.result === 'OK' && res.ITEMS.length > 0) {
      res?.ITEMS.forEach((status: any) => {
        const { ident, title, color } = status.ITEM;
        let colorString = statusColor(color);
        statusArray.push({ ident, title, color: colorString });
      });

      statusArray.unshift({ ident: 'All states', title: '', color: 'black' });
      setStatusListData(statusArray);
      setTaskStatusFormattedList(statusArray);
      return statusArray;
    }
  }, []);

  const getUserCount = async () => {
    // Retrieve selected item
    //console.log('selectedItem', selectedItem);

    // Call API to fetch tasklist line data
    let userList = await accessService.listUser(new ListUserRequest(store.Server, store.SessionId, true, undefined, undefined, '1'));

    //console.log('tasklistResp.ITEMS[0].ITEM.totalRecords', tasklistResp.ITEMS[0].ITEM.totalRecords);

    // If API call is successful
    if (userList.result === 'OK') {
      return userList.count;
    }
  };

  const getUserData = async (totalRecords: number) => {
    let userResp = await accessService.listUser(new ListUserRequest(store.Server, store.SessionId, true, totalRecords));

    if (userResp.result === 'OK') {
      //console.log('userResp', userResp);
      const formattedArray = userResp.USERS.map(({ USER }) => ({
        id: USER.id,
        name: `${USER.name1} ${USER.name3}`,
      }));
      setUserData(formattedArray);
    }
  };

  const getUserName = async (userId: any) => {
    const userResp = await accessService.getUser(new GetUserRequest(store.Server, store.SessionId, userId));
    return userResp.USER.name1 + ' ' + userResp.USER.name3;
  };

  const getTypeofWorkList = async () => {
    const bindedTypeOfWork = getTypeOfWorkFromLogin(TypeOfWorkBinding.Task, store.session.organization);
    const statusArray: any = []
    // let scheduleResp = await schedulerService.getSchedulerSettings(new GetSchedulerSettingsRequest(store.Server, store.SessionId, '4', SettingsItemType.TASK_ITEM_TYPE, 50, 0));
    //console.log('scheduleResp', scheduleResp);
    // 
    // if (scheduleResp.result === "OK") {

    // }
    bindedTypeOfWork?.forEach((status: any) => {
      const { ident, title, color, defaultFor } = status;
      let colorString = statusColor(color);
      statusArray.push({ ident, title, color: colorString, defaultFor });
    });
    setTypeOfWorkFormattedList(statusArray);
    setTypeofWorkList(bindedTypeOfWork);
    return statusArray;
  };

  const getTaskListSearchParams = () => {
    const taskListSearchParams = {
      limit: 0,
      offset: 0,
      rangeStart: new Date('2000-01-01'),
      rangeEnd: new Date('2999-12-31'),
      userId: String(store.UserId),
      folderId: '',
      projectId: '',
      activityId: '',
      anyTime: '0',
      includePast: '0',
      countOnly: '1',
      dateOfInterest: '0',
      groupUsers: '1',
      multiUser: '1',
    } as typeTaskListSearchParam;

    switch (selectedItem?.type) {
      case FPADataTypes.ACTIVITY:
        taskListSearchParams.folderId = dataRef.current.folderID;
        taskListSearchParams.projectId = String(selectedItem?.parent_id);
        taskListSearchParams.activityId = String(selectedItem?.id);
        break;
      case FPADataTypes.PROJECT:
        taskListSearchParams.folderId = String(selectedItem?.parent_id);
        taskListSearchParams.projectId = String(selectedItem?.id);
        delete taskListSearchParams.activityId;
        break;
      case FPADataTypes.FOLDER:
        taskListSearchParams.folderId = String(selectedItem?.id);
        delete taskListSearchParams.activityId;
        delete taskListSearchParams.projectId;
        break;
    }

    return taskListSearchParams;
  };

  const getTaskListCount = async () => {
    // Retrieve selected item
    //console.log('selectedItem', selectedItem);
    // Call API to fetch tasklist line data

    const taskListSearchParams: typeTaskListSearchParam = getTaskListSearchParams();
    delete taskListSearchParams.limit;
    delete taskListSearchParams.offset;

    let taskListResp = await schedulerService.listTask(
      new ListTaskRequest(store.Server, store.SessionId, {
        ...taskListSearchParams,
      })
    );
    //console.log('tasklistResp Count', tasklistResp);
    if (taskListResp.result === 'OK') {
      setTotalTaskListRec(taskListResp.count != 0 ? taskListResp.count : 0);
      return taskListResp.count != 0 ? taskListResp.count : 0;
    }
  };

  let listTaskList = useAsyncList<Character>({
    async load({ cursor }) {
      //console.log('totalTaskListRec', totalTaskListRec);
      //console.log('cursor', cursor);

      setShowLoader(true)
      if (cursor && Number(cursor) * PAGE_SIZE >= totalTaskListRec) {
        setShowLoader(false);
        return { items: [], cursor: undefined };
      }
      let totalRecords = await getTaskListCount();
      totalRecords = totalRecords ? Number(totalRecords) : 0;
      //console.log('totalRecords', totalRecords);
      let currentPage = cursor ? parseInt(cursor) : 0;
      //console.log('currentPage', currentPage);
      let offset = PAGE_SIZE * currentPage;
      //console.log('offset', offset);
      // if (isNaN(offset) || offset >= totalRecords) {
      //   setShowLoader(false);
      //   return { items: [], cursor: undefined };
      // }
      const taskListSearchParams: typeTaskListSearchParam = getTaskListSearchParams();
      let taskListResp = await schedulerService.listTask(
        new ListTaskRequest(store.Server, store.SessionId, {
          ...taskListSearchParams,
          limit: PAGE_SIZE,
          offset: offset,
          countOnly: undefined,
        })
      );

      //console.log('tasklistResp List', taskListResp);


      if (taskListResp.result === 'OK') {
        //console.log('tasklistResp', tasklistResp);

        const statusItem = getClosedStatusIdent(statusListData);//taskStatusList.find((item: any) => item.title === 'Uzavřen');
        const statusId = statusItem ? statusItem.ident : '';

        setTaskListData(taskListResp.ITEMS);
        let taskListData = taskListResp.ITEMS.map(item => ({
          id: item.ITEM.ident,
          ident: item.ITEM.ident,
          title: item.ITEM.title,
          entryTypeName: item.ITEM.entryTypeName,
          entryType: item.ITEM.entryType,
          solutionStatus: item.ITEM.solutionStatus,
          status: item.ITEM.solutionStatus,
          userId: item.ITEM.userId,
          userName: '',
          statusName: '',
          deadLine: moment(item.ITEM.dateTo).format('MM/DD/YYYY'),
          completed: item.ITEM.completed,
          headId: item.ITEM.headId,
          priority: item.ITEM.priority,
          isResolved: item.ITEM?.solutionStatus === statusId,
        }));
        console.log('taskListData', taskListData);
        return updateTaskListData(taskListData).then(updatedData => {
          //console.log('updatedData', updatedData);
          setRowsData(updatedData);
          setShowLoader(false);

          return {
            items: updatedData,
            cursor: String(offset >= totalRecords ? undefined : currentPage + 1),
          };
        });
      } else {
        setShowLoader(false);
        return { items: [], cursor: undefined };
      }
    },
  });

  const updateTaskListData = async (TaskListData: any[]) => {
    const promises = TaskListData?.map(async (item: any) => ({
      ...item,
      userName: await getUserName(item.userId),
      statusName: await getStatusName(item),
      taskStatus: await getTaskStatus(item),
      priority: getPriorityLabel(parseInt(item.priority)),
      entryTypeName: await gettypeOfWorkName(item)
    }));
    const updatedBillingLineData = await Promise.all(promises);
    return updatedBillingLineData;
  };

  const getStatusName = async (item: any) => {
    const statusList = statusListData !== null ? statusListData : await getStatusList();
    const statusObj = statusList.find((status: any) => status.ident === item.solutionStatus);
    return (
      <>
        <CircleFill style={{ paddingRight: '10px' }} size={'18px'} color={statusObj?.color} /> {statusObj?.title}
      </>
    );
  };

  const getTaskStatus = async (item: any) => {
    const statusList = statusListData !== null ? statusListData : await getStatusList();
    const statusObj = statusList.find((status: any) => status.ident === item.solutionStatus);
    return statusObj?.title;
  };


  const gettypeOfWorkName = async (item: any) => {
    const statusList = typeOfWorkFormattedList.length > 0 ? typeOfWorkFormattedList : await getTypeofWorkList();
    const statusObj = statusList.find((status: any) => status?.ident === item.entryType);
    return (
      <>
        <CircleFill style={{ paddingRight: '10px' }} size={'18px'} color={statusObj?.color} /> {statusObj?.title}
      </>
    );
  };

  const priorities = [
    { id: -2, name: _tt('highest_priority'), color: '#F72B1C' },
    { id: -1, name: _tt('high_priority'), color: '#FF9800' },
    { id: 0, name: _tt('normal_priority'), color: '#8BC34A' },
    { id: 1, name: _tt('low_priority'), color: '#14AFF5' },
    { id: 2, name: _tt('lowest_priority'), color: '#8F9FA6' }
  ];

  const getPriority = (id: number) => {
    const priority = priorities.find(p => p.id === id);
    return priority;
  }

  const getPriorityLabel = (id: number) => {
    const priority = getPriority(id)
    if (!priority) return (<></>)

    return (
      <Flex direction={'row'} UNSAFE_style={{ backgroundColor: priority && priority.color }} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.priority_label}>
        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
          <View position={'relative'} UNSAFE_className={styles.priority_label_text_1}>
            <span title={priority.name}>{priority && priority.name}</span>
          </View>
        </Flex>
      </Flex>
    )
  }

  const handleRowClick = (rowId: any): void => {
    //const isSelectedRowNotEmpty = selectedRow && Object.keys(selectedRow).length > 0;
    //console.log('rowId', rowId.currentKey);
    //console.log('rowsData', rowsData);
    const rowData: any = rowsData.find((row: any) => row.id === rowId.currentKey);
    //console.log('rowData', rowData);
    setSelectedRow(rowData);
    setShowAddEditRow(true);
    setIsEdit(false);
    setShowAdd(false)
    isMobile && setIsOpen(true);
    setSelectedKeys(rowId);
  };

  const handleTableRowClick = async (rowId: any) => {
    if (selectedKeys?.has(rowId.currentKey) || rowId === null) {
      return;
    } else {
      setSelectedKeys(rowId)
      const task = await getTask(rowId)
      setShowAdd(true);
      setIsEdit(true);
      setShowAddEditRow(false);
    }
  };

  const handleEditClick = async (item: any) => {
    setSelectedKeys(new Set([item.id]));
    await getTask(item.id);
    setShowAdd(true);
    setIsEdit(true);
    setShowAddEditRow(false);
    isMobile && setIsOpen(false);
  }

  function normalizeEntries(payload: any): any[] {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;

    if (typeof payload === 'object') {
      const keys = Object.keys(payload);
      const allNumeric = keys.length > 0 && keys.every(k => /^\d+$/.test(k));
      if (allNumeric) {
        return keys.sort((a, b) => Number(a) - Number(b)).map(k => payload[k]);
      }
      return [payload];
    }
    return [];
  }

  const getTask = async (selectedId: any) => {
    try {
      const taskResult = await schedulerService.getTask(
        new GetTaskRequest(
          store.Server,
          store.SessionId,
          selectedId.toString(),
          store.UserId.toString()
        )
      );
      if (taskResult.result !== 'OK') return;
      const items = normalizeEntries(taskResult.ITEM);
      const single = items[0] ?? null;
      setSelectedDataRow(single);
      return single;
    } catch (err) {
      console.error('getLayout error:', err);
    } finally {
    }
  };

  const handleRowClose = (): void => {
    setSelectedRow(defaultRowData);
    setShowAddEditRow(false);
    handleUnselect();
  };

  const handleUnselect = () => {
    setSelectedKeys(new Set());
  };

  const getTaskListCreateParams = () => {
    const taskListCreateParams = {
      activityId: '',
      projectId: '',
      folderId: '',
      userId: String(store.UserId),
      title: '',
      typeOfWorkId: '',
      solverId: '',
      solutionStatusId: '',
    } as typeTaskListCreateParam;

    switch (selectedItem?.type) {
      case FPADataTypes.ACTIVITY:
        taskListCreateParams.folderId = dataRef.current.folderID;
        taskListCreateParams.projectId = String(selectedItem?.parent_id);
        taskListCreateParams.activityId = String(selectedItem?.id);
        break;
      case FPADataTypes.PROJECT:
        taskListCreateParams.folderId = String(selectedItem?.parent_id);
        taskListCreateParams.projectId = String(selectedItem?.id);
        break;
      case FPADataTypes.FOLDER:
        taskListCreateParams.folderId = String(selectedItem?.id);
        break;
    }

    return taskListCreateParams;
  };

  const addRecord = async (record: any) => {
    try {
      setShowLoader(true);
      //console.log('addRecord', record);

      // let taskStatus = await schedulerService.getSchedulerSettings(new GetSchedulerSettingsRequest(store.Server, store.SessionId, '1', SettingsItemType.TASK_ITEM_TYPE, 50, 0));

      const taskListCreateParams: typeTaskListCreateParam = getTaskListCreateParams();
      taskListCreateParams.title = record.title;
      taskListCreateParams.typeOfWorkId = record.entryType;
      taskListCreateParams.solverId = record.userId;
      taskListCreateParams.solutionStatusId = '131817081';
      taskListCreateParams.u_item = {};

      let { result, EXCEPTION } = await schedulerService.createTask(
        new CreateTaskRequest(
          store.Server,
          store.SessionId,
          generateTaskItem(
            taskListCreateParams.activityId,
            taskListCreateParams.projectId,
            taskListCreateParams.folderId,
            taskListCreateParams.userId,
            taskListCreateParams.title,
            taskListCreateParams.typeOfWorkId,
            taskListCreateParams.solverId,
            taskListCreateParams.solutionStatusId,
            taskListCreateParams.u_item
          )
        )
      );

      //console.log('addRecord result', result);

      if (result === 'OK') {
        //await getTaskListCount();
        handleRowClose();
        listTaskList.reload();
        ToastQueue.positive(t('record_saved_successfully', { ns: 'layout_components' }), { timeout: 3000 });
      } else {
        ToastQueue.negative(EXCEPTION.reason, { timeout: 3000 });
      }
    } catch (error: any) {
      ToastQueue.negative(error.message, { timeout: 3000 });
    } finally {
      setShowLoader(false);
    }
  };

  const updateRecord = async (record: any) => {
    try {
      setShowLoader(true);
      //console.log('TaskListData', TaskListData);
      //console.log('update record', record);
      let itemRow = taskListData.find((row: any) => row.ITEM.ident == record.id);
      //console.log('itemRow', itemRow);

      let { result, EXCEPTION } = await schedulerService.updateTask(
        new UpdateTaskRequest(store.Server, store.SessionId, {
          ...itemRow.ITEM,
          entryType: record.entryType,
          title: record.title,
          solverId: record.userId,
          USER: { id: record.userId },
          headUserId: record.userId,
          GARANT: { userId: store.UserId == record.userId ? '' : store.UserId },
        })
      );

      // console.log('result', result);
      if (result === 'OK') {
        handleRowClose();
        listTaskList.reload();
        ToastQueue.positive(t('record_updated_successfully', { ns: 'layout_components' }), { timeout: 3000 });
      } else {
        ToastQueue.negative(EXCEPTION.reason, { timeout: 3000 });
      }
    } catch (error) {
    } finally {
      setShowLoader(false);
    }
  };

  function getClosedStatusIdent(taskStatusList: any[]) {
    const candidates = (taskStatusList || [])
      .filter(s => s?.ident && typeof s.ident === "string")
      .filter(s => s.ident !== "All states")      // ignore fake row
      .filter(s => (s.title || "").trim() !== ""); // ignore blanks

    const closed = candidates.find(s => CLOSED_TITLES.has(normalizeText(s.title)));
    console.log('close status', closed)
    return closed;
  }

  const updateStatus = async (taskId: any) => {
    try {
      setShowLoader(true);
      setCheckSelected(false);
      const statusItem = getClosedStatusIdent(statusListData);
      const statusId = statusItem ? statusItem.ident : '';
      let itemRow = taskListData.find((row: any) => row.ITEM.ident == taskId);
      const payLoad = {
        ...itemRow.ITEM,
        completed: new Date().toISOString(),
        solutionStatus: statusId,
        solverId: store.UserId.toString(),
        USER: { id: store.UserId.toString() },
        headUserId: store.UserId.toString(),
      };
      let { result, EXCEPTION } = await schedulerService.updateTask(
        new UpdateTaskRequest(store.Server, store.SessionId, {
          ...payLoad,
        })
      );

      // console.log('result', result);
      if (result === 'OK') {
        handleRowClose();
        listTaskList.reload();
        ToastQueue.positive(t('record_updated_successfully', { ns: 'layout_components' }), { timeout: 3000 });
      } else {
        ToastQueue.negative(EXCEPTION.reason, { timeout: 3000 });
      }
    } catch (error) {
    } finally {
      setShowLoader(false);
    }
  };

  const deleteRecord = async (record: any) => {
    try {
      setShowLoader(true);
      //console.log('record', record);

      let result = await schedulerService.deleteTask(new DeleteTaskRequest(store.Server, store.SessionId, record.id, false, record.headId));

      //console.log('result', result);
      if (result.result === 'OK') {
        //await getTaskListCount();
        handleRowClose();
        listTaskList.reload();
        ToastQueue.positive(t('record_deleted_successfully', { ns: 'layout_components' }), { timeout: 3000 });
      } else {
        ToastQueue.negative(result.EXCEPTION.reason, { timeout: 3000 });
      }
    } catch (error) {
    } finally {
      setShowLoader(false);
    }
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  // Use the utility for dynamic height calculations
  const { tableHeight, containerHeight, tableStyles } = useTableViewHeight(
    listTaskList.items.length,
    {
      headerHeight: 50,
      rowHeight: 50,
      maxVisibleRows: 5,
      containerExtraSpace: 50,
      maxContainerHeight: 400,
      showOverflow: false
    }
  );

  const handleAddNew = () => {
    setShowAdd(true);
  };

  const handleAddNewClose = () => {
    setShowAdd(false);
    setIsEdit(false);
  };

  const TaskCloseDialog = ({ close, taskId }: { close: () => void; taskId: any }) => (
    <Dialog size="S">
      <Flex UNSAFE_className={styles.close_pop_up_parent}>
        <Content UNSAFE_className={styles.close_pop_up_header}>{t('close_task', { ns: 'layout_components' })}</Content>
        <View UNSAFE_className={styles.close_pop_up_line}></View>
        <View UNSAFE_className={styles.close_pop_up_warning_text}>{t('are_you_sure_you_want_to_close_task', { ns: 'layout_components' })}</View>
        <View UNSAFE_className={styles.buttons_parent_close}>
          <View UNSAFE_className={styles.button_cancel}>
            <Link width={'155px'} UNSAFE_className={styles.close_pop_up_cancel_text} isQuiet onPress={close}>
              {t('no', { ns: 'layout_components' })}
            </Link>
          </View>
          <View UNSAFE_className={styles.button_confirm_close}>
            <Link UNSAFE_className={styles.close_pop_up_confirm_text} isQuiet onPress={() => updateStatus(taskId)}>
              {t('yes_close', { ns: 'layout_components' })}
            </Link>
          </View>
        </View>
        <View UNSAFE_className={styles.ellipse_div}>
          <View UNSAFE_className={styles.close_alert_icon}>
            <AlertIconFill size={72} />
          </View>
        </View>
      </Flex>
    </Dialog>
  );


  const COLUMN_WIDTHS: Record<string, string> = {
    title: '25%',
    priority: '8%',
    completed: '5%',
    edit: '5%',
  };

  if (showLoader) {
    return (
      <Flex width="100%" justifyContent={'center'} marginTop={10}>
        <ProgressCircle aria-label="Loading…" isIndeterminate />
      </Flex>
    );
  } else {
    return (
      <>
        <View position={'relative'} width={'100%'} minHeight={containerHeight}>
          <Flex direction={'column'} gap={'size-150'} position={'absolute'} top={0} left={0} right={0} width={'100%'} UNSAFE_style={{ zIndex: 1 }}>
            <Flex direction={'row'} alignItems={'start'} justifyContent={'start'}>
              <Content position={'relative'} UNSAFE_className={styles.heading_text}>
                {t('task_list', { ns: 'layout_components' })}
              </Content>
              <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'size-100'} UNSAFE_className={styles.icon_add_parent}>
                {/* {showTopControls && ( bilal bhai mjay smj  nahi aai yeh kahan sa set kerna ha client k pass add k buttons show nahi ho rahay thay so main na isko comment ker diya*/}
                <>
                  <Content>
                    <Link
                      isQuiet
                      onPress={e => {
                        defaultRowData.userId = String(store.UserId);
                        setSelectedRow(defaultRowData);
                        handleUnselect();
                        handleAddNew();
                      }}
                    >
                      <i className="bi bi-plus fs-5">
                        <View UNSAFE_className={styles.icon_add_text}>{t('add_task', { ns: 'layout_components' })} </View>
                      </i>
                    </Link>
                  </Content>
                  <Content>
                    <Link
                      isQuiet
                      onPress={e => {
                        defaultRowData.userId = String(store.UserId);
                        setSelectedRow(defaultRowData);
                        handleUnselect();
                        setShowAddEditRow(true);
                        isMobile && setIsOpen(true);
                      }}
                    >
                      <i className="bi bi-plus fs-5">
                        <View UNSAFE_className={styles.icon_add_text}>{t('quick_task', { ns: 'layout_components' })} </View>
                      </i>
                    </Link>
                  </Content>
                </>
                {/* )} */}
              </Flex>
            </Flex>
            <Flex direction={'column'} width={'100%'} UNSAFE_style={{ maxWidth: '100%' }}>
              <TableView
                UNSAFE_className="tblLayoutComponent"
                aria-label="Task list line"
                selectionMode="single"
                selectedKeys={selectedKeys}
                selectionStyle="highlight"
                width="100%"
                height={tableHeight}
                marginBottom="size-250"
                UNSAFE_style={{ ...tableStyles }}
                onSelectionChange={handleRowClick}
                onAction={handleTableRowClick}
              >
                <TableHeader columns={isMobile ? columnsDataMobile : columnsData}>
                  {(column: any) => (
                    <Column
                      key={column.key}
                      showDivider
                      width={COLUMN_WIDTHS[column.key] as any}
                      align={column.key === 'edit' ? 'end' : 'start'}
                    >
                      {column.name}
                    </Column>
                  )}
                </TableHeader>

                <TableBody
                  items={listTaskList.items}
                  loadingState={listTaskList.loadingState}
                  onLoadMore={listTaskList.loadMore}
                >
                  {(item: any) => (
                    <Row key={item.id}>
                      {(columnKey: any) => {
                        if (columnKey === 'completed') {
                          return (
                            <Cell>
                              {item.isResolved ? (
                                <Checkbox isDisabled isSelected />
                              ) : (
                                <DialogTrigger isDismissable type="modal">
                                  <Checkbox
                                    isSelected={checkSelected}
                                    onChange={() => setCheckSelected(true)}
                                  />
                                  {close => <TaskCloseDialog close={close} taskId={item.id} />}
                                </DialogTrigger>
                              )}
                            </Cell>
                          );
                        }

                        if (columnKey === 'edit') {
                          return (
                            <Cell>
                              <Flex justifyContent="end">
                                <ActionButton
                                  isQuiet
                                  aria-label="Edit task"
                                  onPress={(e) => {
                                    handleEditClick(item);
                                  }}
                                >
                                  <EditIcon size={22} />
                                </ActionButton>
                              </Flex>
                            </Cell>
                          );
                        }

                        return (
                          <Cell>
                            {columnKey === 'userName' ? (
                              <>
                                <img
                                  width="28px"
                                  height="28px"
                                  alt="Owner picture"
                                  src="../../../../../../assets/images/avatar--desktop--light@2x.png"
                                />
                                &nbsp;&nbsp;{(item as any)[columnKey]}
                              </>
                            ) : (
                              (item as any)[columnKey]
                            )}
                          </Cell>
                        );
                      }}
                    </Row>
                  )}
                </TableBody>
              </TableView>

            </Flex>
          </Flex>
        </View>
        {showAddEditRow && (
          <View paddingBottom={isMobile ? 70 : 0}>
            {isMobile ? (
              <DialogContainer
                isDismissable
                onDismiss={() => {
                  setIsOpen(false);
                }}
              >
                {isOpen && (
                  <Dialog size="L">
                    <Heading>
                      {' '}
                      {selectedRow.ident === 0 ? t('add', { ns: 'layout_components' }) : t('edit', { ns: 'layout_components' })} {t('task', { ns: 'layout_components' })}
                    </Heading>
                    <Content>
                      <TaskListAddEdit
                        id={String(selectedItem?.id)}
                        defaultRowData={defaultRowData}
                        typeofWorkList={typeofWorkList}
                        userData={userData}
                        selectedRowData={selectedRow}
                        handleRowClose={handleRowClose}
                        addRecord={addRecord}
                        updateRecord={updateRecord}
                        deleteRecord={deleteRecord}
                        closeDialog={closeDialog}
                        styles={styles}
                      />
                    </Content>
                  </Dialog>
                )}
              </DialogContainer>
            ) : (
              <TaskListAddEdit
                id={String(selectedItem?.id)}
                defaultRowData={defaultRowData}
                typeofWorkList={typeofWorkList}
                userData={userData}
                selectedRowData={selectedRow}
                handleRowClose={handleRowClose}
                addRecord={addRecord}
                updateRecord={updateRecord}
                deleteRecord={deleteRecord}
                closeDialog={closeDialog}
                styles={styles}
              />
            )}
          </View>
        )}
        <DialogContainer onDismiss={handleAddNewClose}>
          {showAdd && <AddUpdateTask
            task={selectedDataRow}
            isEdit={isEdit}
            onClose={handleAddNewClose}
            refreshDetailView={listTaskList.reload}
            handleRefreshAddNew={listTaskList.reload}
            taskStatusList={taskStatusFormattedList}
            typeOfWorkList={typeOfWorkFormattedList}
            userList={userData}
            context={getTaskListCreateParams()} />
          }
        </DialogContainer>
      </>
    );
  }
}

export const TaskListComponent = LayoutComponent(TaskList);
